import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/routes/login/login.component';
import { ShellComponent } from './features/layout/routes/shell/shell.component';
import { NotEmployerComponent } from './features/auth/routes/not-employer/not-employer.component';
import { EmployerGuard } from './features/auth/services/employer.guard';
import { DeductionRatesComponent } from './features/deduction-rates/routes/deduction-rates.component';
import { LocalDeductionRatesComponent } from './features/deduction-rates/routes/local-deduction-rates/local-deduction-rates.component';
import { AuthRedirectGuard } from './features/auth/services/auth-redirect.guard';


export const routes: Routes = [
  {
    path: 'auth',
    component: LoginComponent,
    // canActivate: [loginGuard],
    title: 'Arbeidsgiver | Logg inn',
  },
  {
    path: 'brukermanual',
    loadComponent: () =>
      import('./features/layout/routes/user-manual/user-manual.component').then((mod) => mod.UserManualComponent),
    title: 'Arbeidsgiver | Brukermanual',
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/dashboard/routes/dashboard.component').then((mod) => mod.DashboardComponent),
        title: 'Arbeidsgiver | Fagforbundet',
        // canActivate: [MsalGuard],
        canActivate: [EmployerGuard],
        pathMatch: 'full',
      },
      {
        path: 'deduction-lists',
        loadComponent: () =>
          import('./features/deduction-lists/routes/deduction-lists.component').then((mod) => mod.DeductionListsComponent),
        title: 'Trekklister | Fagforbundet',
        data: { breadcrumb: 'Trekklister' },
        canActivate: [EmployerGuard],
      },
      {
        path: 'digital-deduction-lists',
        loadComponent: () =>
          import('./features/digital-deduction-lists/routes/digital-deduction-lists.component').then((mod) => mod.DigitalDeductionListsComponent),
        title: 'Digital | Fagforbundet',
        data: { breadcrumb: 'Digital Opplastning' },
        canActivate: [EmployerGuard],
      },
      {
        path: 'admin',
        loadComponent: () => import('./features/admin/routes/admin.component').then((mod) => mod.AdminComponent),
        title: 'Admin | Fagforbundet',
        data: { breadcrumb: 'Admin' },
        // canActivate: [MembershipGuard],
      },
      {
        path: 'user-profile',
        loadComponent: () =>
          import('./features/user-profile/routes/user-profile.component').then((mod) => mod.UserProfileComponent),
        title: 'Din profil | Fagforbundet',
        data: { breadcrumb: 'Din profil' },
        // Access controlled by parent AuthRedirectGuard (logged-in users only)
      },
      {
        path: 'apply-employer',
        component: NotEmployerComponent,
        // canActivate: [loginGuard],
        title: 'Søk om arbeidsgiver',
      },
      {
        path: 'deduction-rates',
        component: DeductionRatesComponent,
        // canActivate: [loginGuard],
        title: 'Kontingentsatser',
      },
      {
        path: 'deduction-rates/local',
        component: LocalDeductionRatesComponent,
        // canActivate: [loginGuard],
        title: 'Lokale Kontingentsatser',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
